import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/articles';

export default function FeaturedSection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            热门推荐
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            精选全网最热门、最受欢迎的资源，不容错过的精彩内容
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featuredArticles.map((article, idx) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative w-full h-52 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 bg-primary-500 text-background-50 text-xs rounded-full whitespace-nowrap">
                    {article.categoryName}
                  </span>
                </div>
                {idx === 0 && (
                  <div className="absolute top-3 right-3">
                    <span className="px-3 py-1 bg-accent-500 text-background-50 text-xs rounded-full whitespace-nowrap">
                      热门
                    </span>
                  </div>
                )}
              </div>
              <div className="p-5">
                <h3 className="font-heading text-lg text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 line-clamp-2 mb-3">
                  {article.description}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{article.publishDate}</span>
                  <span>{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}